<template>
  <div class="select">
    <input
      class="select-bar"
      readonly="readonly"
      type="text"
      v-model="selectItem.label"
      @focus="onFocus"
      @blur="onBlur()"
    />
    <div class="select-drawer" v-show="isDrawerOpen">
      <div class="select-drawer-item" v-for="item in options" :key="item.value" @mousedown="onSelect(item, $event)">
          {{ item.label }}
        </div>    
    </div>    
  </div>
</template>

<script>
export default {
  name: 'Select',
  data() {
    return {
      isDrawerOpen: false
    }
  },
  props: {
    modelValue: String,
    options: Array
  },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  computed: {
    selectItem() {
      return this.options
        && this.options.find(item => item.value === this.modelValue) || {
          label: '',
          value: ''
        }
    }
  },
  methods: {
    onFocus() {
      this.isDrawerOpen = true
    },
    onBlur() {
      this.isDrawerOpen = false
    },
    onSelect(item, e) {
      this.$emit('change', item.value)
    }
  },
}
</script>

<style scoped lang="less">
.select {
  width: 0.87rem;
  height: 0.32rem; 
  text-align: left;
  font-size: 0.11rem;
  color: rgba(74, 47, 26, 0.8);
  &-bar {
    width: 0.87rem;
    height: 0.32rem;  
    line-height: 0.27rem;
    padding-left: 0.11rem;
    font-size: 0.11rem;
    border: solid #000000 0.04rem;
  }
  .select-drawer {
    position: absolute;
    z-index: 99;
    width: 0.87rem;
    box-shadow: 0 0 0 0.008rem rgba(102, 54, 11, 0.50);
    background-color: rgba(251, 247, 224, 1);
    border-radius: 0.03rem;

    &-item {
      width: 99%;
      height: 0.27rem;
      line-height: 0.27rem;
      white-space: nowrap;
      padding-left: 0.11rem;
    }
    &-item:nth-of-type(odd) {
      color: rgba(74, 47, 26, 0.8);
      background-color: rgba(237, 218, 185, 0.3);
    }
    &-item:nth-of-type(even) {
      color: rgba(74, 47, 26, 0.6);
      background-color: rgba(251, 247, 224, 1);
    }
    &-item:nth-last-of-type(1) {
      border-bottom-left-radius: 0.03rem;
      border-bottom-right-radius: 0.03rem;
    }
  }  
}

</style>